import { render, staticRenderFns } from "./uploadVoucher.vue?vue&type=template&id=2be35da7&scoped=true"
import script from "./uploadVoucher.vue?vue&type=script&lang=js"
export * from "./uploadVoucher.vue?vue&type=script&lang=js"
import style0 from "./uploadVoucher.vue?vue&type=style&index=0&id=2be35da7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be35da7",
  null
  
)

export default component.exports